import { CalendarClock } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { ClassTimetablePage } from '@/pages/timetable/ClassTimetablePage'
import { CoverPage } from '@/pages/timetable/CoverPage'
import { FamilyTimetablePage } from '@/pages/timetable/FamilyTimetablePage'
import { StaffTimetablePage } from '@/pages/timetable/StaffTimetablePage'
import { TeacherTimetablesPage } from '@/pages/timetable/TeacherTimetablesPage'
import { TimetableSetupPage } from '@/pages/timetable/TimetableSetupPage'
import type { AppModule } from '../moduleRegistry'

export const module: AppModule = {
  id: 'timetable',
  schoolModule: 'timetable',
  routes: {
    admin: [
      {
        path: 'timetable',
        element: <RequirePermission permission="academic.view" />,
        children: [
          { index: true, element: <ClassTimetablePage /> },
          { path: 'teachers', element: <TeacherTimetablesPage /> },
          { path: 'cover', element: <CoverPage /> },
          { path: 'setup', element: <TimetableSetupPage /> },
        ],
      },
    ],
    staff: [{ path: 'timetable', element: <StaffTimetablePage /> }],
    family: [{ path: 'timetable', element: <FamilyTimetablePage /> }],
  },
  nav: {
    admin: [
      {
        group: 'Academics',
        order: 45,
        item: {
          label: 'Timetable',
          to: '/admin/timetable',
          icon: CalendarClock,
          permission: 'academic.view',
          children: [
            {
              label: 'Class timetables',
              to: '/admin/timetable',
              permission: 'academic.view',
              end: true,
              keywords: 'routine schedule grid lessons',
            },
            {
              label: 'Teacher timetables',
              to: '/admin/timetable/teachers',
              permission: 'academic.view',
              keywords: 'routine schedule staff load',
            },
            {
              label: 'Substitute cover',
              to: '/admin/timetable/cover',
              permission: 'academic.view',
              keywords: 'absent teacher replacement substitute supply cover',
            },
            {
              label: 'Periods & rooms',
              to: '/admin/timetable/setup',
              permission: 'academic.view',
              keywords: 'bell schedule breaks classrooms labs',
            },
          ],
        },
      },
    ],
    staff: [
      {
        order: 12,
        item: {
          label: 'My timetable',
          to: '/staff/timetable',
          icon: CalendarClock,
          keywords: 'routine schedule lessons',
        },
      },
    ],
    family: [
      {
        order: 15,
        item: {
          label: 'Timetable',
          to: '/portal/timetable',
          icon: CalendarClock,
          keywords: 'routine schedule lessons',
        },
      },
    ],
  },
}
